import styled from 'styled-components';

export const WhiteBox = styled.div`
  background-color: #fff;
  border-radius: 16px;
  padding: 16px 12px;
  margin-top: -16px;
`;

export const OtpSection = styled.p`
  padding: 12px 16px 30px 16px;
  background-color: #000;
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  border-radius: 16px 16px 0px 0px;
  font-family: 'Lato';
`;

export const Otp = styled.span`
  padding: 0px 4px;
`;

export const OtpSpan = styled.span`
  font-size: 16px;
  line-height: 20px;
  font-family: 'Lato';
  font-weight: 900;
  border-radius: 4px;
  padding: 2px 4px;
  background-color: #4a4a4a;

  &:not(:last-child) {
    margin-right: 4px;
  }
`;

export const HeaderSection = styled.div`
  padding-bottom: 16px;
  border-bottom: 1px solid #d8d8d8;
`;

export const HeaderTopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const VehicleNo = styled.p`
  font-size: 24px;
  line-height: 30px;
  font-weight: 900;
  font-family: 'Lato';
  margin-bottom: 12px;
  text-transform: uppercase;
`;

export const Facilities = styled.div`
  display: flex;
  align-items: center;
  margin-top: 18px;
`;

export const Facility = styled.span`
  font-size: 12px;
  font-weight: 400;
  font-family: 'Lato';
  line-height: 16px;
  color: #4a4a4a;
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-right: 16px;
  }

  img {
    height: 12px;
    width: 12px;
    border-radius: 2px;
    margin-right: 4px;
  }
`;

export const VehicleImgView = styled.div`
  width: 80px;
  height: 74px;
  background: #E8F0FB;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const VehicleLogoWrap = styled.div`
  position: absolute;
  z-index: 1;
  top: -12px;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0px 1px 7px 0px #00000033;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 24px;
  width: 50px;
`;

export const VehicleLogo = styled.img`
  height: 16px;
  object-fit: contain;
`;

export const VehicleImg = styled.img`
  height: 46px;
  width: 71px;
  object-fit: contain;
`;

export const BtnsWpr = styled.div`
  display: flex;
  align-items: center;
  margin-top: 24px;
  gap: 16px;
`;

export const GuideSection = styled.div`
  padding: 16px 0px;
  border-bottom: 1px solid #d8d8d8;
`;

export const Label = styled.p`
  font-size: 18px;
  line-height: 22px;
  font-weight: 900;
  font-family: 'Lato';
`;

export const SubLabel = styled.p`
  font-size: 14px;
  line-height: 16px;
  font-family: 'Lato';
  font-weight: 600;
  margin-top: 12px;
  display: flex;

  span {
    min-width: 1em;
  }
`;

export const ListItems = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 28px;
`;

export const ListItem = styled.li`
  border-radius: 8px;
  overflow: hidden;
  list-style: none;
  position: relative;
  width: 144px;
  height: 94px;

  &.singleItem {
    width : 100% !important ;
  }

  &:not(:last-child){
    margin-right: 16px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    &.singleItem {
      width : 100% !important ;
    }
  }

  .label {
    padding: 8px 0px;
    background: #000;
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 100%;
    font-size: 14px;
    font-weight: 900;
    font-family: 'Lato';
    line-height: 18px;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
  }
`;

export const PBFullImageView = styled.div`
  position: absolute;
  z-index: 999;
  height: 100vh;
  background: #000;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageCrossIc = styled.div`
  position: absolute;
  top: 25px;
  right: 45px;
  cursor: pointer;

  &:after {
    display: inline-block;
    content: "\00d7";
    color: #fff;
    font-size: 30px;
    padding: 5px;
  }
`;

export const KioskImage = styled.img`
  width: 100%;
  height: 100%;
`;